// extracted by mini-css-extract-plugin
export var heroImage = "_ml-1";
export var modal = "_ml-0";